const CATEGORY_ORDER = [
  'Інтерактивні та навчальні іграшки',
  'Дитячі іграшкові машинки',
  'М’які іграшки',
  'Ігрові набори',
  'Дитяча зброя для ігор',
  'Дитячі конструктори',
];

const sortCategories = (categories: Category[] = []) => [...categories].sort((a, b) => {
  const aIndex = CATEGORY_ORDER.indexOf(a.name);
  const bIndex = CATEGORY_ORDER.indexOf(b.name);
  if (aIndex === -1 && bIndex === -1) return 0;
  if (aIndex === -1) return 1;
  if (bIndex === -1) return -1;
  return aIndex - bIndex;
});

export default sortCategories;
